import { useSyncExternalStore } from "react";
import { toastStore } from "./toast";
import type { ToastApi, ToastItem, ToastStore } from "./types";

/** Subscribe to a store's live toasts (defaults to the module-level store). */
export function useToastStore(store: ToastStore = toastStore): readonly ToastItem[] {
  return useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
}

/**
 * The toast API for use in components. Identical to the module-level `toast`
 * (stable reference) — no provider is required.
 */
export function useToast(store: ToastStore = toastStore): ToastApi {
  return store.api;
}
